import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import ButtonGrp from '../../../components/UIComponent/Buttons/ButtonGrp';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { ManuallyInvoicePopup } from './ManuallyInvoiceTable';
import { decryptAES } from '../../../utils/Encryption';
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import moment from 'moment';
import AccountMasterServices from '../../../services/axiosServices/apiServices/AccountMasterServices';
import OtherFormsServices from '../../../services/axiosServices/apiServices/OtherFormsServices';
import { Navigate } from 'react-router-dom';
import { permission } from '../../../utils/enums/ValidationMessage';

export default class ManuallyInvoice extends Component {

    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.accountMasterServices = new AccountMasterServices();
        this.SwalServices = new SwalServices();
        this.otherFormsServices = new OtherFormsServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isTable2Expanded: false,
            isShown: false,
            rowData: [],
            colDefs: [],
            invoiceRowData: [],
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            partyAccountList: [],
            texStructureList: [],
            accountHeadList: [],
            paymentDetails: {
                totalQuantity: "",  // add
                totalAmt: "",  // add
                extraCharges: "",
                totalDiscountAmt: "",
                taxableAmt: "",
                taxAmt: "",  // add
                totalWithTax: "",  // add
                finalAmt: "",  // Add 
                adjustableAmt: "",  // add new
            },
            taxList: [
                {
                    value: 1,
                    label: "LOCAL",
                },
                {
                    value: 2,
                    label: "O.G.S",
                },
            ],
            invoiceObject: {
                idInvoice: 0,
                invoiceNo: '',
                invoiceDate: '',
                idCustomer: 0,
                refNo: '',
                refDate: '',
                idAccountHead: 0,
                taxTypeId: 1,
                taxType: ''
            },
            entryBy: '',
            invoiceItem: {
                idInvoice: "",
                updateStatus: 0,
                quantity: "",
                product: "",
                rate: "",
                amount: "",
                idTaxStructure: 0,
                cgst: "",
                sgst: "",
                igst: "",
                cgstAmt: "",
                sgstAmt: "",
                igstAmt: "",
                netTotal: "",
                remarks: "",
                taxtTypeName: "INTRASTATE",
                index: null
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForInvoice: {
                invoiceDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "invoice date"
                        ),
                    },
                ],
                idCustomer: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "customer"
                        ),
                    },
                ],
            },
            validationRulesForInvoiceItem: {
                product: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "product"
                        ),
                    },
                ],
                quantity: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "quantity"
                        ),
                    },
                ],
                rate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "rate"
                        ),
                    },
                ],

            },
        }
    }

    handleChangeForPayment = (event, name) => {
        let value = event.target.value;
        let details = this.state.paymentDetails;
        details[name] = value;
        this.setState({ paymentDetails: details }, () => {
            this.finalCalculation()
        });
    }

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }

        let prop = getAuthProps()
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0, entryBy: prop.name }, () => {
                this.procSelectAllRecordsSP();
                this.usp_Master_PartyAccountSelect()
            });
        }
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "Manually Invoice",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key) !== undefined ? this.getColumnWidth(key) : window.innerWidth * 0.06,
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            hide: ["idInvoice", "chequeDate", "sR.No"].includes(key) ? true : false,
                            // pinned: key === "receiptNo" || key === "date" || key === "refNo" || key === "bankName" || key === "account" ? "left" : undefined,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.toLowerCase().includes("date") ? (params) => {
                                if (!params.value) return "";
                                const date = new Date(params.value);
                                return moment(date).format('DD-MM-YYYY')
                            } : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "Manually Invoice",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id, "Manually Invoice");
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    openPopUpFromURLId = (id) => {
        let details = this.state.invoiceObject
        details.idInvoice = id
        this.setState({ invoiceObject: details }, () => {
            this.getOtherFormsManualInvoiceByID(this.state.invoiceObject.idInvoice);
        });
    };

    getColumnWidth = (key) => {
        const colwidth = {
            "invoiceNo": window.innerWidth * 0.05,
            "invoiceDate": window.innerWidth * 0.08,
            "accountHead": window.innerWidth * 0.12,
            "customer": window.innerWidth * 0.2,
            "refNo": window.innerWidth * 0.08,
            "refDate": window.innerWidth * 0.08,
            "totalQty": window.innerWidth * 0.08,
            "totalAmount": window.innerWidth * 0.08,
            "netTotal": window.innerWidth * 0.1,
        }
        return colwidth[key]
    }

    usp_Master_PartyAccountSelect = () => {
        this.accountTransactionServices.usp_Master_PartyAccountSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let dynamicData = response.responseItem.responseContent;
                if (dynamicData.length > 0) {
                    dynamicData = dynamicData.map((x) => ({
                        value: x.idPartyAccount,
                        label: x.partyACName,
                    }));

                    this.setState({ partyAccountList: dynamicData }, () => {
                        this.getTaxStructure();
                    }, () => {
                        if (this.gridApi) {
                            this.gridApi.hideOverlay();
                        }
                    });
                } else {
                    this.getTaxStructure();
                }
            }
        });
    }


    getTaxStructure = () => {
        this.accountTransactionServices.getTaxStructure(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent;
                res = res.map((x) => ({
                    value: x.idTaxStructure,
                    label: x.taxStructureName,
                }));
                this.setState({ texStructureList: res }, () => {
                    this.getMasterAccountHeadSelect()
                })
            } else {
                this.getMasterAccountHeadSelect()
            }
        });
    }

    getMasterAccountHeadSelect = () => {
        this.accountTransactionServices.usp_Master_GeneralProductSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {

                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    value: x.idGeneralProduct,
                    label: x.productName,
                }));
                this.setState({ accountHeadList: data });
            }
        });
    }

    procSelectAllRecord2GridviewSP = (id, formname) => {
        let request = {
            id: id,
            formname: formname,
            allowToRateVisible: 1,
        }
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                if (response.statusCode == 200 && response.responseItem !== null) {
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            filter: true,
                            floatingFilter: true,
                            // hide: ["ssmA_TimeStamp",].includes(key) ? true : false,
                            flex: 1,
                            minWidth: this.getColumnWidth2(key) !== undefined ? this.getColumnWidth2(key) : window.innerWidth * 0.06,
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    }
                }
            });
        }
    }
    getColumnWidth2 = (key) => {
        const colwidth = {
            "idInvoiceDetails": window.innerWidth * 0.05,
            "idInvoice": window.innerWidth * 0.05,
            "itemDetails": window.innerWidth * 0.15,
            "quantity": window.innerWidth * 0.06,
            "rate": window.innerWidth * 0.05,
            "amount": window.innerWidth * 0.06,
            "sgst": window.innerWidth * 0.05,
            "sgstAmt": window.innerWidth * 0.06,
            "cgst": window.innerWidth * 0.05,
            "cgstAmt": window.innerWidth * 0.06,
            "igst": window.innerWidth * 0.05,
            "igstAmt": window.innerWidth * 0.06,
            "idTaxGroup": window.innerWidth * 0.05,
            "netTotal": window.innerWidth * 0.08,
            "remarks": window.innerWidth * 0.1,
            "ssmA_TimeStamp": window.innerWidth * 0.12,
        }
        return colwidth[key]
    }

    handleCellClick = (event) => {
        let data = this.state.invoiceItem;
        data.idInvoice = event.data[this.state.colName];
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ invoiceItem: data, validState: validState })
        this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "Manually Invoice");
    };

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.otherFormsServices.getInvoiceCountForManualInvoice(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let total = response.responseItem.responseContent[0].totalCount + 1

                let formatted = '';
                if (total.toString().length === 1) {
                    formatted = '00' + total;
                } else if (total.toString().length === 2) {
                    formatted = '0' + total;
                } else {
                    formatted = total.toString();
                }
                let invoiceObject = this.state.invoiceObject
                invoiceObject.invoiceNo = formatted
                this.setState({ invoiceObject: invoiceObject }, () => {

                    this.setState({ isModalOpen: true }, () => {
                        this.resetDetailsFields();
                        this.resetInvoiceItems()
                        this.setState({ invoiceRowData: [] })
                    })
                })
            }
        });
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getOtherFormsManualInvoiceByID(event.data.idInvoice);
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState
        });
    };

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    isValidAllFieldsForInvoice = () => {
        const newValidState = isValidForm(
            this.state.invoiceObject,
            this.state.validationRulesForInvoice,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    isValidAllFieldsForInvoiceItem = () => {
        const newValidState = isValidForm(
            this.state.invoiceItem,
            this.state.validationRulesForInvoiceItem,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    setOpenModel = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        }
        this.setState({ isModalOpen: !this.state.isModalOpen });
    };

    closePopup = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        } else {
            this.setState({ isModalOpen: false, });
        }
    };

    handleChangeForInvoice = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.invoiceObject;
        details[name] = value;
        this.setState({ invoiceObject: details });
    }

    handleChangeForInvoiceItem = (event, name) => {
        let value = event.target.value.toUpperCase();
        let details = this.state.invoiceItem;
        details[name] = value;
        if (name === 'quantity' || name === 'rate') {
            details.amount = Number(details.quantity) * Number(details.rate)
        }
        this.setState({ invoiceItem: details }, () => {
            if (name === 'quantity' || name === 'rate') {
                this.calculatePricing()
            }
        });
    }

    resetDetailsFields = () => {
        let details = this.state.invoiceObject
        details.idInvoice = 0
        details.invoiceDate = ''
        details.refNo = ''
        details.refDate = ''
        details.idAccountHead = ''
        details.idCustomer = ''
        details.taxTypeId = ''
        details.taxType = ''
        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({
            validState: validState,
            invoiceObject: details
        });
    }

    resetInvoiceItems = () => {
        let invoiceItem = this.state.invoiceItem;
        invoiceItem.product = "";
        invoiceItem.idTaxStructure = 0;
        invoiceItem.quantity = "";
        invoiceItem.rate = "";
        invoiceItem.amount = "";
        invoiceItem.sgst = "";
        invoiceItem.sgstAmt = "";
        invoiceItem.cgst = "";
        invoiceItem.cgstAmt = "";
        invoiceItem.igst = "";
        invoiceItem.igstAmt = "";
        invoiceItem.netTotal = "";
        invoiceItem.remarks = "";
        invoiceItem.index = null;
        invoiceItem.taxtTypeName = 'INTRASTATE'
        this.setState({ invoiceItem: invoiceItem })
    }

    setFilterParameters = (event, name) => {
        let details = this.state.invoiceObject;
        details[name] = event.value;
        this.setState({ invoiceObject: details });
    }

    setFilterParametersForInvoiceItem = (event, name) => {
        let details = this.state.invoiceItem;
        details[name] = event.value;
        this.setState({ invoiceItem: details }, () => {
            if (name === 'idTaxStructure') {
                this.getTaxStructureSelectbyID(this.state.invoiceItem.idTaxStructure);
            }
        });
    }

    getTaxStructureSelectbyID = (id) => {
        this.accountTransactionServices.getTaxStructureSelectbyID(id).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent[0];
                let data = this.state.invoiceItem;
                data.sgst = res.sgst;
                data.cgst = res.cgst;
                data.igst = res.igst;
                this.setState({ invoiceItem: data }, () => {
                    this.calculatePricing()
                });
            }
        });
    }

    calculatePricing = () => {
        let invoiceItem = { ...this.state.invoiceItem };
        if (invoiceItem.amount > 0) {
            invoiceItem.quantity = Number(invoiceItem.quantity)
            invoiceItem.rate = Number(invoiceItem.rate)
            invoiceItem.sgstAmt = invoiceItem.taxtTypeName === "INTRASTATE" ? Number(invoiceItem.amount) * Number(invoiceItem.sgst) / 100 : 0;
            invoiceItem.cgstAmt = invoiceItem.taxtTypeName === "INTRASTATE" ? Number(invoiceItem.amount) * Number(invoiceItem.cgst) / 100 : 0;
            invoiceItem.igstAmt = invoiceItem.taxtTypeName === "INTRASTATE" ? 0 : Number(invoiceItem.amount) * Number(invoiceItem.igst) / 100;
            invoiceItem.netTotal = Number(Math.round((Number(invoiceItem.amount) + Number(invoiceItem.sgstAmt) + Number(invoiceItem.cgstAmt) + Number(invoiceItem.igstAmt))).toFixed(2));

            if (invoiceItem.tcsPercentage > 0) {
                invoiceItem.tcsAmt = Number(invoiceItem.netTotal) * Number(invoiceItem.tcsPercentage) / 100;
                invoiceItem.netTotal = Math.round(Number(invoiceItem.netTotal) + Number(invoiceItem.tcsAmt));
            } else {
                invoiceItem.tcsAmt = 0
            }
            this.setState({
                invoiceItem: invoiceItem
            })
        } else {
            invoiceItem.sgstAmt = 0;
            invoiceItem.cgstAmt = 0;
            invoiceItem.igstAmt = 0;

            invoiceItem.netTotal = 0;
            invoiceItem.tcsAmt = 0;
            invoiceItem.netTotal = 0;

            this.setState({
                invoiceItem: invoiceItem
            })
        }
    }

    insertItem = (key) => {
        const isValidAllFields = this.isValidAllFieldsForInvoiceItem();
        if (isValidAllFields) {
            let data = [...this.state.invoiceRowData];
            let invoiceItem = this.state.invoiceItem;
            let invoiceRowData = {};
            invoiceRowData.product = invoiceItem.product;
            invoiceRowData.quantity = invoiceItem.quantity;
            invoiceRowData.rate = invoiceItem.rate;
            invoiceRowData.amount = invoiceItem.amount;
            invoiceRowData.idTaxStructure = invoiceItem.idTaxStructure;
            invoiceRowData.taxGroup = this.state.texStructureList.find(x => x.value === invoiceItem.idTaxStructure)?.label
            invoiceRowData.sgstAmt = invoiceItem.sgstAmt;
            invoiceRowData.sgst = invoiceItem.sgst;
            invoiceRowData.cgstAmt = invoiceItem.cgstAmt;
            invoiceRowData.cgst = invoiceItem.cgst;
            invoiceRowData.igstAmt = invoiceItem.igstAmt;
            invoiceRowData.igst = invoiceItem.igst;
            invoiceRowData.netTotal = invoiceItem.netTotal;
            invoiceRowData.remarks = invoiceItem.remarks;

            if (invoiceItem.index !== null && invoiceItem.index >= 0) {
                data[invoiceItem.index] = invoiceRowData;
            } else {
                data.push(invoiceRowData);
            }
            this.setState({ invoiceRowData: data }, () => {
                let data = this.state.invoiceRowData;
                let invoiceItem = this.state.invoiceItem

                if (data.length > 0) {
                    this.setState({
                        invoiceItem: invoiceItem,
                    }, () => {
                        this.resetInvoiceItems();
                        this.finalCalculation()
                    });
                }
            });
        }
    }

    finalCalculation = () => {
        let data = this.state.invoiceRowData;
        let finalAmountCal = this.state.paymentDetails;

        finalAmountCal.totalQuantity = 0;
        finalAmountCal.totalAmt = 0;
        finalAmountCal.taxAmt = 0;
        finalAmountCal.totalWithTax = 0;
        finalAmountCal.finalAmt = 0;

        data.map((x) => {
            finalAmountCal.totalQuantity += Number(x.quantity);
            finalAmountCal.totalAmt += Number(x.amount);
            finalAmountCal.taxAmt += Number(x.sgstAmt) + Number(x.cgstAmt) + Number(x.igstAmt);
            finalAmountCal.finalAmt += Number(x.netTotal);
        });


        finalAmountCal.totalWithTax = Number(finalAmountCal.totalAmt) + Number(finalAmountCal.taxAmt);
        finalAmountCal.finalAmt = Number(finalAmountCal.totalWithTax).toFixed(2);
        finalAmountCal.totalAmt = Number(finalAmountCal.totalAmt).toFixed(2);
        finalAmountCal.taxAmt = Number(finalAmountCal.taxAmt).toFixed(2);
        finalAmountCal.totalWithTax = Number(finalAmountCal.totalWithTax).toFixed(2);
        finalAmountCal.finalAmt = Math.round(Number(finalAmountCal.finalAmt) + Number(finalAmountCal.adjustableAmt));
        finalAmountCal.adjustableAmt = finalAmountCal.adjustableAmt;

        this.setState({ paymentDetails: finalAmountCal });
    }

    onRowDoubleClickedForManualInvoiceDetails = (event) => {
        let details = event.data
        let invoiceItem = this.state.invoiceItem
        invoiceItem = details
        invoiceItem.index = event.rowIndex
        this.setState({ invoiceItem: invoiceItem })

        let validState = this.state.validState;
        validState.isValid = true;
        validState.error = {};
        this.setState({ validState: validState });
    };

    deleteItem = () => {
        let details = this.state.invoiceItem
        let data = [...this.state.invoiceRowData];
        data.splice(details.index, 1);
        this.setState({ invoiceRowData: data }, () => {
            this.resetInvoiceItems();
        })
    }

    getOtherFormsManualInvoiceByID = (id) => {
        this.otherFormsServices.getOtherFormsManualInvoiceByID(id).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent[0];
                if (res) {
                    let data = this.state.invoiceObject;
                    let paymentDetails = this.state.paymentDetails;
                    data.idInvoice = res.idInvoice;
                    data.updateStatus = 1;
                    data.invoiceDate = res.invoiceDate ? moment(res.invoiceDate).format('YYYY-MM-DD') : "";
                    data.refDate = res.refDate ? moment(res.refDate).format('YYYY-MM-DD') : "";
                    data.refNo = res.refNo;
                    data.idAccountHead = res.idAccountHead;
                    data.e_Date = res.e_Date ? res.e_Date : null;
                    data.idCustomer = res.idCustomer;
                    data.invoiceNo = res.invoiceNo;

                    paymentDetails.totalQuantity = res.totalQuantity ? res.totalQuantity : "";
                    paymentDetails.totalAmt = res.totalAmt ? res.totalAmt : "";
                    paymentDetails.taxAmt = res.taxAmt ? res.taxAmt : "";
                    paymentDetails.totalWithTax = res.totalWithTax ? res.totalWithTax : "";
                    paymentDetails.adjustableAmt = res.adjustableAmt ? res.adjustableAmt : "";
                    paymentDetails.finalAmt = res.finalAmt ? res.finalAmt : "";

                    data.taxTypeId = Number(res.taxType) > 0 ? Number(res.taxType) : 1;
                    this.setState({
                        invoiceObject: data,
                        paymentDetails: paymentDetails,
                        isModalOpen: true
                    });
                    this.otherFormsServices.getOtherFormsManuallyInvoiceItemsByID(id).then((responseData) => {
                        if (responseData.statusCode == 200 && responseData.responseItem !== null) {
                            let value = responseData.responseItem.responseContent;
                            let invoiceItem = this.state.invoiceItem;
                            //debugger;
                            let manuallyInvoiceItemList = [];
                            if (value.length > 0) {
                                value.map((x) => {
                                    let request = {
                                        product: x.itemDetails,
                                        quantity: x.quantity,
                                        rate: x.rate,
                                        amount: x.amount,
                                        idTaxStructure: Number(x.idTaxGroup) > 0 ? Number(x.idTaxGroup) : 0,
                                        taxGroup: Number(x.idTaxGroup) > 0 ? (this.state.texStructureList.find(y => y.value === Number(x.idTaxGroup))?.label || '') : '',
                                        cgst: x.cgst,
                                        cgstAmt: x.cgstAmt,
                                        sgst: x.sgst,
                                        sgstAmt: x.sgstAmt,
                                        igst: x.igst,
                                        igstAmt: x.igstAmt,
                                        netTotal: x.netTotal,
                                        remarks: x.remarks,
                                        taxtTypeName: "INTRASTATE",
                                    }
                                    manuallyInvoiceItemList.push(request);
                                });
                                if (manuallyInvoiceItemList.length > 0) {
                                    this.setState({
                                        invoiceRowData: manuallyInvoiceItemList,
                                    }, () => {
                                        if (this.state.paymentDetails.totalQuantity == "" || this.state.paymentDetails.totalAmt == "") {
                                            this.finalCalculation()
                                        }
                                        this.resetInvoiceItems();
                                    });
                                }
                                this.setState({ invoiceItem: invoiceItem });
                            }
                        }
                    });

                }
            }
        });
    }

    submit = () => {
        const isValidAllFields = this.isValidAllFieldsForInvoice();
        if (isValidAllFields) {
            if (this.state.invoiceRowData.length === 0) {
                this.SwalServices.Error("Please add manual invoice details.");
            } else {
                let details = this.state.invoiceObject;
                let paymentDetails = this.state.paymentDetails;
                let details2 = this.state.invoiceRowData;
                let manuallyInvoiceItemList = [];
                details2.map((x) => {
                    let request = {
                        product: x.product,
                        quantity: x.quantity,
                        rate: x.rate,
                        amount: x.amount,
                        idTaxStructure: x.idTaxStructure,
                        sgst: x.sgst,
                        sgstAmt: x.sgstAmt,
                        cgst: x.cgst,
                        cgstAmt: x.cgstAmt,
                        igst: x.igst,
                        igstAmt: x.igstAmt,
                        netTotal: x.netTotal,
                        remarks: x.remarks,
                    }
                    manuallyInvoiceItemList.push(request);
                });
                let totalQty = this.state.invoiceRowData.reduce((sum, item) => sum + Number(item.quantity), 0);
                let totalAmount = this.state.invoiceRowData.reduce((sum, item) => sum + Number(item.amount), 0);
                let netTotal = this.state.invoiceRowData.reduce((sum, item) => sum + Number(item.netTotal), 0);
                if (details !== "") {
                    let requestData = {
                        idInvoice: details.idInvoice,
                        updateStatus: details.updateStatus,
                        invoiceDate: (details.invoiceDate && details.invoiceDate !== 'Invalid date') ? details.invoiceDate : null,
                        refNo: details.refNo,
                        refDate: (details.refDate && details.refDate !== 'Invalid date') ? details.refDate : null,
                        idAccountHead: details.idAccountHead,
                        idCustomer: details.idCustomer,
                        taxType: details.taxTypeId,
                        totalQty: totalQty,
                        totalAmount: totalAmount,
                        netTotal: netTotal,
                        idCompany: this.state.idCompany,
                        e_Date: details.e_Date ? details.e_Date : new Date().toISOString(),
                        e_IDUser: this.state.idUser,
                        isUpdated: details.updateStatus > 0 ? true : false,
                        u_IDUser: details.updateStatus > 0 ? this.state.idUser : 0,
                        isDeleted: false,
                        deletedDate: null,
                        d_IDUser: 0,
                        manuallyInvoiceItemList: manuallyInvoiceItemList,
                        entryBy: this.state.entryBy,

                        totalQuantity: paymentDetails.totalQuantity,
                        totalAmt: paymentDetails.totalAmt,
                        taxAmt: paymentDetails.taxAmt,
                        totalWithTax: paymentDetails.totalWithTax,
                        //extraCharges: paymentDetails.extraCharges,
                        //discount: paymentDetails.disAmt,
                        finalAmt: paymentDetails.finalAmt,
                        adjustableAmt: paymentDetails.adjustableAmt,
                    }
                    this.otherFormsServices.submitManuallyInvoiceInsertUpdate(requestData)
                        .then((response) => {
                            if (response.statusCode == 200 && response.responseItem !== null) {
                                let dynamicData = response.responseItem.responseContent;
                                if (dynamicData !== null) {
                                    if (this.state.invoiceItem.updateStatus === 1) {
                                        this.SwalServices.Success("Updated successfully.");
                                    } else {
                                        this.SwalServices.Success("Saved successfully.");
                                    }
                                    if (this.state.urlId) {
                                        this.setState({ route: '/ledger-report' });
                                    } else {
                                        this.resetDetailsFields();
                                        this.setState(
                                            { isModalOpen: false },
                                            () => {
                                                this.procSelectAllRecordsSP();
                                            }
                                        );
                                    }
                                } else {
                                    this.procSelectAllRecordsSP();
                                }
                            } else {
                                this.setState(
                                    { isModalOpen: false },
                                    () => {
                                        this.SwalServices.Error(response.message);
                                        this.procSelectAllRecordsSP();
                                    }
                                );
                            }
                        });
                }
            }
        }
    }

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='manual-invoice'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <ButtonGrp buttons={['add', 'print']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.openPopUpForUpdateItem(),
                                print: this.handlePrint,
                            }}
                        />
                        <ManuallyInvoicePopup
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            invoiceObject={this.state.invoiceObject}
                            invoiceItem={this.state.invoiceItem}
                            handleChangeForInvoice={this.handleChangeForInvoice.bind(this)}
                            handleChangeForInvoiceItem={this.handleChangeForInvoiceItem.bind(this)}
                            close={this.closePopup.bind(this)}
                            validState={this.state.validState}
                            invoiceRowData={this.state.invoiceRowData}

                            partyAccountList={this.state.partyAccountList}
                            texStructureList={this.state.texStructureList}
                            accountHeadList={this.state.accountHeadList}
                            taxList={this.state.taxList}
                            setFilterParameters={this.setFilterParameters.bind(this)}
                            setFilterParametersForInvoiceItem={this.setFilterParametersForInvoiceItem.bind(this)}
                            insertItem={this.insertItem.bind(this)}
                            onRowDoubleClickedForManualInvoiceDetails={this.onRowDoubleClickedForManualInvoiceDetails.bind(this)}
                            deleteItem={this.deleteItem.bind(this)}
                            submit={this.submit.bind(this)}
                            paymentDetails={this.state.paymentDetails}
                            handleChangeForPayment={this.handleChangeForPayment.bind(this)}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 300px)" }}>
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Manually Invoice</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    onGridReady={this.onGridReady}
                                    onCellClicked={this.handleCellClick}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>

                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    headerHeight={65}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
